// ✅ File: src/ReportsAnalytics.js
import React, { useState, useEffect } from 'react';
import './ReportsAnalytics.css';
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';

export default function ReportsAnalytics() {
  const [selected, setSelected] = useState('This Week');
  const [analyticsData, setAnalyticsData] = useState(null);

  useEffect(() => {
    localStorage.setItem('userRole', 'admin');
    fetch(`/api/get-analytics-data.php?period=${selected.toLowerCase()}`)
      .then((res) => res.json())
      .then((data) => setAnalyticsData(data));
  }, [selected]);

  const handleFilterChange = (period) => setSelected(period);

  if (!analyticsData) return <p>Loading analytics...</p>;

  return (
    <div className="reports-analytics-container">
      <h2>Reports & Analytics</h2>

      <div className="filter-buttons">
        {['Today', 'This Week', 'This Month'].map((period) => (
          <button
            key={period}
            className={selected === period ? 'active' : ''}
            onClick={() => handleFilterChange(period)}
          >
            {period}
          </button>
        ))}
      </div>

      <div className="section">
        <h4>User Engagement Overview</h4>
        <div className="metric-box">
          <p>Total Active Users ({selected.toLowerCase()}): <strong>1,324</strong></p>
          <ul>
            <li>Daily Active Students: 894</li>
            <li>Daily Active Mentors: 87</li>
            <li>Avg. Session Duration: 38 mins</li>
          </ul>
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={analyticsData.activeUsers}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="students" stroke="#8884d8" name="Students" />
              <Line type="monotone" dataKey="mentors" stroke="#82ca9d" name="Mentors" />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="grid-2">
        <div className="section">
          <h4>Course Performance Analytics</h4>
          <ul>
            <li>Full Stack Java – 92%</li>
            <li>Cybersecurity Essentials – 88%</li>
            <li>AI/ML Bootcamp – 87%</li>
          </ul>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={analyticsData.coursePerformance}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="course" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="completion" fill="#8884d8" name="Completion %" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div className="section">
          <h4>Mentor Effectiveness</h4>
          <ul>
            <li>Avg. Mentor Rating: 4.6</li>
            <li>Sessions Conducted: 2,238</li>
            <li>Feedback Flags: 30</li>
            <li>Top Mentor: Karan (5 courses completed)</li>
          </ul>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={analyticsData.mentorStats}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="rating" fill="#ff7300" name="Rating" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="grid-2">
        <div className="section">
          <h4>Student Progress Trends</h4>
          <ul>
            <li>Avg. Quiz Score: 74%</li>
            <li>Weekly Progress Spike: +12%</li>
            <li>Avg. Completion Time: 47 days</li>
            <li>Top Student: 5 courses</li>
          </ul>
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={analyticsData.studentProgress}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="week" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="avgScore" stroke="#82ca9d" name="Avg Score" />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="section">
          <h4>Platform Quality Insights</h4>
          <ul>
            <li>Flags Raised: 15</li>
            <li>Resolved Reports: 11</li>
            <li>Content Quality: 4.3 / 5</li>
            <li>Downtime: 0.5h last 30 days</li>
          </ul>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={analyticsData.platformInsights}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="metric" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="value" fill="#00C49F" name="Value" />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}
